export default "__VITE_ASSET__C8PPhM$M__"